module.exports = __webpack_public_path__ + "assets/img/1-02.61d2980a.png";